import isServer from './isServer';

export default function isLocalhost(req = {}) {
  const hostname = isServer() ? req.hostname : window.location.hostname;
  return hostname === 'localhost' || hostname === '127.0.0.1';
}



// WEBPACK FOOTER //
// ./src/utils/isLocalhost.js